import React, { useState } from "react";
import { Box, Stack, Typography, Avatar, IconButton } from "@mui/material";
import ArrowBackIos from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIos from "@mui/icons-material/ArrowForwardIos";
import FormatQuote from "@mui/icons-material/FormatQuote";

const testimonialData = [
  {
    id: 1,
    name: "Rihana",
    role: "Full Stack Engineer",
    avatar: "R",
    avatarBg: "#ff6b6b",
    text: "Joining Rubaai has been a game-changer for my career. As a Full-Stack Engineer, I work on exciting projects that push me to grow every day. The remote-friendly culture gives me the freedom to balance work and life, while the team's collaborative spirit makes even the toughest challenges enjoyable. Rubaai is more than just a fintech company",
  },
  {
    id: 2,
    name: "Kiruba",
    role: "Full Stack Engineer",
    avatar: "K",
    avatarBg: "#4ecdc4",
    text: "Joining Rubaai has been a game-changer for my career. As a Full-Stack Engineer, I work on exciting projects that push me to grow every day. The remote-friendly culture gives me the freedom to balance work and life, while the team's collaborative spirit makes even the toughest challenges enjoyable. Rubaai is more than just a fintech company,it's a place where your ideas matter and your growth is a priority.",
  },
  {
    id: 3,
    name: "Liseyananth",
    role: "QA Tester",
    avatar: "L",
    avatarBg: "#45b7d1",
    text: "Joining Rubaai has been a turning point in my career. As a QA professional, I get to ensure the highest standards across every product we release. The team's commitment to quality, collaboration, and innovation motivates me daily. The remote-friendly culture offers a great work-life balance, and the supportive environment makes tackling challenges rewarding.",
  },
];

export function TeamTestimonialsSlider() {
  const [currentIndex, setCurrentIndex] = useState(1);
  const sideOffset = 100;

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : testimonialData.length - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev < testimonialData.length - 1 ? prev + 1 : 0));
  };

  return (
    <Box sx={{ position: "relative", width: "100%", overflow: "hidden", py: 8 }}>
      {/* Cards Container */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          height: { xs: 380,sm:400, md: 500 },
        }}
      >
        {testimonialData.map((testimonial, index) => {
          const isCenter = index === currentIndex;
          const translateX = (index - currentIndex) * (sideOffset + 10);

          return (
            <Box
              key={testimonial.id}
              sx={{
                position: "absolute",
                width: { xs: "90%", md: "60%" },
                maxWidth: 1000,
                p: { xs: 2, md: 4 },
                borderRadius: 3,
                border: "1px solid white",
                color: "white",
                display: "flex",
                flexDirection: "column",
                justifyContent:{ xs: "flex-start",sm:"flex-start", md: "space-between"},
                height: { xs: 350,sm:350, md: 500 },
                pointerEvents: isCenter ? "auto" : "none",
                opacity: 1,
                transform: `translateX(${translateX}%) scale(${isCenter ? 1 : 0.85})`,
                transition: "all 0.5s ease",
                overflow: "hidden",
                mx: "auto",
              }}
            >
              {isCenter && (
                <>
                  <Box sx={{ mb: { xs: 1, sm: 1.5, md: 2 } }}>
                    <FormatQuote
                      sx={{
                        fontSize: { xs: 32, md: 60 },
                        transform: "scaleX(-1)",
                        color: "rgba(255, 255, 255, 1)",
                        mb: { xs: 1, sm: 1, md: 2 },
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: { xs: 13, sm: 14, md: 16 },
                        lineHeight: { xs: 1.4, sm: 1.5, md: "35px" },
                        textAlign: "justify",
                        mb: { xs: 1, sm: 2, md: 0.5 },
                      }}
                    >
                      {testimonial.text}
                    </Typography>
                    <Box display="flex" justifyContent="flex-end">
                      <FormatQuote
                        sx={{
                          fontSize: { xs: 32, md: 60 },
                          color: "rgba(255, 255, 255, 1)",
                          mt: { xs: 0.5, sm: 0.5, md: 0.5 },
                        }}
                      />
                    </Box>
                  </Box>

                  {/* Avatar + Name + Role */}
                  <Stack
                    direction="row"
                    spacing="8px"
                    alignItems="center"
                    sx={{
                      mt: { xs:1, sm: 2, md: -10 },
                       mb: { xs:5, sm: 2 },
                      flexShrink: 0,
                      flexWrap: "nowrap",
                    }}
                  >
                    <Avatar
                      sx={{
                        width: { xs: 36, sm: 40, md: 50 },
                        height: { xs: 36, sm: 40, md: 50 },
                        backgroundColor: testimonial.avatarBg,
                        fontSize: { xs: 20, sm: 22, md: 30 },
                        fontWeight: 800,
                        color: "#120d21",
                      }}
                    >
                      {testimonial.avatar}
                    </Avatar>

                    <Box sx={{ minWidth: 0 }}>
                      <Typography sx={{ fontSize: { xs: 15, sm: 16, md: 22 }, fontWeight: 800, lineHeight: 1.2, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        {testimonial.name}
                      </Typography>
                      <Typography sx={{ fontSize: { xs: 12, sm: 13, md: 15 }, opacity: 0.9, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        {testimonial.role}
                      </Typography>
                    </Box>
                  </Stack>
                </>
              )}
            </Box>
          );
        })}
      </Box>

      {/* Navigation Arrows */}
      <IconButton
        onClick={handlePrevious}
        sx={{
          position: "absolute",
          top: "50%",
          left: 16,
          transform: "translateY(-50%)",
          color: "white",
          bgcolor: "rgba(255,255,255,0.1)",
          "&:hover": { bgcolor: "rgba(255,255,255,0.2)" },
        }}
      >
        <ArrowBackIos />
      </IconButton>

      <IconButton
        onClick={handleNext}
        sx={{
          position: "absolute",
          top: "50%",
          right: 16,
          transform: "translateY(-50%)",
          color: "white",
          bgcolor: "rgba(255,255,255,0.1)",
          "&:hover": { bgcolor: "rgba(255,255,255,0.2)" },
        }}
      >
        <ArrowForwardIos />
      </IconButton>

      {/* Pagination Dots */}
      <Stack
        direction="row"
        spacing={1}
        sx={{ position: "absolute", bottom: 16, left: "50%", transform: "translateX(-50%)" }}
      >
        {testimonialData.map((_, idx) => (
          <Box
            key={idx}
            onClick={() => setCurrentIndex(idx)}
            sx={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              bgcolor: currentIndex === idx ? "white" : "rgba(255,255,255,0.5)",
              cursor: "pointer",
              transition: "all 0.3s ease",
              "&:hover": { bgcolor: "white" },
            }}
          />
        ))}
      </Stack>
    </Box>
  );
}
